import { createFileRoute } from "@tanstack/react-router";
import { PipelineListPage } from "@client/components/doc-center/pipelines";

export const Route = createFileRoute("/_app/data-center/tmpl/")({
  validateSearch: (search: Record<string, unknown>): { kind?: string } => ({
    kind: typeof search.kind === "string" ? search.kind : undefined,
  }),
  component: PipelineListRoute,
});

function PipelineListRoute() {
  const { kind } = Route.useSearch();
  return <PipelineListPage initialKind={kind} />;
}
